import React from 'react';
import './HomieHero.css';
import heroVideo from '../../landing-banner-video-03.mp4';

const HomieHero: React.FC = () => {
  return (
    <div className="homie-hero">
      <div className="homie-hero__video-container">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="homie-hero__video"
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

export default HomieHero;
